import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { usersService } from './users.service';
import { coinsService } from './coins.service';

@Injectable({
    providedIn: 'root'
})
export class utilityService {
    public userAuthData: any;
    public userLogData: any;
    public isAuthenticated: boolean = false;
    public userToken: any;
    public currentUrl: string;
    previousUrl:any;
    public loginUser: any;
    
    public userDetail = new BehaviorSubject<any>(null);
    userDetail$ = this.userDetail.asObservable();

    public assessCoinsCount = new BehaviorSubject<any>(null);
    assessCoinsCount$ = this.assessCoinsCount.asObservable();




    constructor(
        private location: Location,
        private router: Router,
        private userService: usersService,
        private coinService: coinsService
    ) {
        this.currentUrl = this.router.url;
        this.previousUrl = null;

        this.router.events
            .pipe(filter((event: any) => event instanceof RoutesRecognized), pairwise())
            .subscribe((events: RoutesRecognized[]) => {
                if (events[0].urlAfterRedirects) {
                    this.previousUrl = events[0].urlAfterRedirects;
                }
                if (events[1].urlAfterRedirects) {
                    this.currentUrl = events[1].urlAfterRedirects;

                }
            });
    }


    public getPreviousUrl() {
        if (this.previousUrl == null) {
            this.router.navigateByUrl('/user/login')
        } else {
            this.router.navigateByUrl(this.previousUrl)
        }
    }

    goBack() {
        this.location.back();
    }

    //  generateUniqueId(): string {
    //     // return uuidv4();
    //     const random4DigitNumber = Math.floor(100056 + Math.random() * 9000);
    //     return random4DigitNumber.toString();
    // }


    generateUniqueId(): string {
        const length = 6;
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * chars.length);
            result += chars.charAt(randomIndex);
        }
        return result;
    }
    getUserId(){
        return null;
    }


      //reset page
  reset() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    let currentUrl = this.router.url + '?';
    this.router.navigateByUrl(currentUrl)
      .then(() => {
        this.router.navigated = false;
        this.router.navigate([this.router.url]);
      });
  }


  formatDecimal(value: number | null): string {
    if (value === null) {
        return '--';
    }

    const decimalPart = value % 1;
    if (decimalPart !== 0) {
        return value.toFixed(2);
    } else {
        return Math.floor(value).toString();
    }
}

    updateCoinsIARCounter(userId: string){
        console.log('user id' , userId)
        this.coinService.getAllIARCoins(userId).subscribe(res => {
            console.log('res' , res);
            this.assessCoinsCount.next(res.data);
        })
    }


}
